import { ReactElement } from "react";
import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

export default function Withdraw({
  height = "24px",
  width = "24px"
}: IconProps): ReactElement {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5794_296476)">
        <path
          d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z"
          fill="#D32F2F"
        />
        <path
          d="M6.65165 8L7.53553 8.88392L6.245 10.174H11.5V11.424H6.541L7.53553 12.4194L6.65165 13.3033L4 10.6516L6.65165 8Z"
          fill="white"
        />
        <rect fill="white" height="12" width="1.25" x="13" y="4" />
      </g>
      <defs>
        <clipPath id="clip0_5794_296476">
          <rect
            fill="white"
            height="20"
            transform="matrix(-1 0 0 1 20 0)"
            width="20"
          />
        </clipPath>
      </defs>
      <title>withdraw</title>
    </svg>
  );
}
